import { type FormEvent, useState } from "react";
import { ApiError, api, setToken } from "../lib/api";
import { Notice } from "../components/Shell";

export function SignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [consent, setConsent] = useState(true);
  const [sent, setSent] = useState<{ sandboxOtp?: string } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function requestOtp(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      setSent(await api<{ sandboxOtp?: string }>("/v1/auth/otp/request", { body: { mobile } }));
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not send the OTP.");
    } finally {
      setBusy(false);
    }
  }

  async function verify(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const r = await api<{ token: string }>("/v1/auth/otp/verify", { body: { mobile, otp, contactConsent: consent } });
      setToken(r.token);
      onSignedIn();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not verify the OTP.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <section className="signin-hero">
        <div className="column">
          <h1>Research-backed trading calls, on record.</h1>
          <p>Sign in with your mobile number to join a Finversify service or see your calls.</p>
        </div>
      </section>
      <div className="column">
        {error && <Notice tone="bad">{error}</Notice>}
        {!sent ? (
          <form onSubmit={requestOtp}>
            <label className="field">
              <span>Mobile number</span>
              <input type="tel" inputMode="numeric" autoComplete="tel-national" placeholder="98765 43210" value={mobile} onChange={(e) => setMobile(e.target.value)} required />
            </label>
            <label className="check">
              <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} />
              <span>Finversify may contact me about my account and services by call, SMS, WhatsApp or email.</span>
            </label>
            <button className="btn" disabled={busy || mobile.replace(/\D/g, "").length < 10}>
              {busy ? "Sending…" : "Send OTP"}
            </button>
          </form>
        ) : (
          <form onSubmit={verify}>
            <p>
              We sent a 6-digit code to <strong className="num">{mobile}</strong>.{" "}
              <button
                type="button"
                className="link"
                onClick={() => {
                  setSent(null);
                  setOtp("");
                }}
              >
                Change number
              </button>
            </p>
            {sent.sandboxOtp && <Notice tone="warn">Test mode: the OTP is {sent.sandboxOtp}.</Notice>}
            <label className="field">
              <span>OTP</span>
              <input
                className="input-otp"
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={6}
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                required
              />
            </label>
            <button className="btn" disabled={busy || otp.length !== 6}>
              {busy ? "Checking…" : "Sign in"}
            </button>
          </form>
        )}
      </div>
    </>
  );
}
